import { useRouter } from "next/router";
export const withRouting = (to: string) => {
  const Routing: React.FC = () => {
    const router = useRouter();
    router.push(to);
    return null;
  };
  return Routing;
};